import {
  MetaPixelEvent,
  MetaPixelPayload,
  Transport,
  TransportConfig,
} from './meta-pixel.types';

const transports: Transport[] = [];

export const registerTransport = (
  transport: Transport,
  config: TransportConfig,
): void => {
  const existing = transports.find((item) => item.name === transport.name);
  if (existing) {
    console.warn(
      `Meta Pixel: transport "${transport.name}" already registered, skipping`,
    );
    return;
  }

  transport.init(config);
  transports.push(transport);
  console.info(`Meta Pixel: registered "${transport.name}"`);
};

export const track = (
  eventName: MetaPixelEvent,
  payload?: MetaPixelPayload,
): void => {
  transports.forEach((transport) => {
    try {
      transport.track(eventName, payload);
    } catch (error) {
      console.error(`Meta Pixel: ${transport.name} track error:`, error);
    }
  });
};

export const getTransports = (): readonly Transport[] => transports;

export const reset = (): void => {
  transports.length = 0;
};
